gsap.registerPlugin(ScrollTrigger);


// Custom Cursor

const isTouchDevice = 'ontouchstart' in window;
const createCursorFollower = () => {
    const $el = document.querySelector('.cursor-follower');

    window.addEventListener('mousemove', (e) => {
        
        const { target, x, y } = e;
        const isTargetLinkOrBtn = target?.closest('a') || target?.closest('button') || target?.closest('select') || target?.closest('.svg-titles');

        gsap.to($el, {
            x: x + 3,
            y: y + 3,
            duration: 0.1,
            ease: 'power4', 
            opacity: isTargetLinkOrBtn ? 0.6 : 1,
            transform: `scale(${isTargetLinkOrBtn ? 1.5 : 1})`,
        });
    });
    
    document.addEventListener('mouseleave', (e) => {
        gsap.to($el, {
            duration: 0.7,
            opacity: 0,
        });
    });
};

if (!isTouchDevice) {
    createCursorFollower();
}


